<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/system/dashboard")
          i.nav-icon.cui-dashboard
          span.ml-1 {{ $t("ui.dashboard") }}
  div.row
    div.col-md-12
      div.card
        //- div.card-header
        div.card-body
          div.row.mb-3
            div.col-sm-12.col-md-6.col-lg-6
              div
                div.animated.fadeIn.col-12(style="background: white;")
                  line-chart(:chartData="secondDataSet" :options="chartOptions")
            div.col-sm-12.col-md-6.col-lg-6
              div
                div.animated.fadeIn.col-12(style="background: white;")
                  line-chart(:chartData="firstDataSet" :options="chartOptions")
          div.row
            div.col-sm-12.col-md-6.col-lg-6
              div.row
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-success
                    div.card-header
                      i.fas.fa-money-bill-alt
                      span.font-weight-bold(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalDeposit)" :title="$n(totalDeposit, 'currency')") {{ $n(totalDeposit, 'currency') }}
                        div.text-uppercase.text-muted(:title="$n(totalDepositCount, 'integer')") {{ $t("ui.deposit_count") }} : {{ $n(totalDepositCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-danger
                    div.card-header
                      i.fas.fa-coins
                      span.font-weight-bold(:title="$t('ui.withdrawal')") {{ $t("ui.withdrawal") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalWithdrawal)" :title="$n(totalWithdrawal, 'currency')") {{ $n(totalWithdrawal, 'currency') }}
                        div.text-uppercase.text-muted(:title="$n(totalWithdrawalCount, 'integer')") {{ $t("ui.withdrawal_count") }} : {{ $n(totalWithdrawalCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-info
                    div.card-header
                      i.fas.fa-users
                      span.font-weight-bold(:title="$t('ui.active_player')") {{ $t("ui.active_player") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalActivePlayer)" :title="$n(totalActivePlayer, 'integer')") {{ $n(totalActivePlayer, 'integer') }}
                        div.text-uppercase.text-muted(:title="$n(totalBetCount, 'integer')") {{ $t("ui.bet_count") }} : {{ $n(totalBetCount, 'integer') }}
              div.row
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-warning
                    div.card-header
                      i.fas.fa-money-bill-wave
                      span.font-weight-bold(:title="$t('ui.winlose')") {{ $t("ui.winlose") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalWinlose)" :title="$n(totalWinlose, 'currency')") {{ $n(totalWinlose, 'currency') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-warning
                    div.card-header
                      i.fas.fa-dollar-sign
                      span.font-weight-bold(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalValidTurnover)" :title="$n(totalValidTurnover, 'currency')") {{ $n(totalValidTurnover, 'currency') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-warning
                    div.card-header
                      i.fas.fa-users
                      span.font-weight-bold(:title="$t('ui.total_member')") {{ $t("ui.total_member") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalMemberCount)" :title="$n(totalMemberCount, 'integer')") {{ $n(totalMemberCount, 'integer') }}
              div.row
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-success
                    div.card-header
                      i.fas.fa-user
                      span.font-weight-bold(:title="$t('ui.total_referee')") {{ $t("ui.total_referee") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalRefereeCount)" :title="$n(totalRefereeCount, 'integer')") {{ $n(totalRefereeCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-danger
                    div.card-header
                      i.fas.fa-pen
                      span.font-weight-bold(:title="$t('ui.verified_signup')") {{ $t("ui.verified_signup") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value.row.col-sm-12
                          h1(:class="$helpers.fontClassName(totalVerifiedCount)" :title="$n(totalVerifiedCount, 'integer')") {{ $n(totalVerifiedCount, 'integer') }}
                          h1 &nbsp;/&nbsp;
                          h1(:class="$helpers.fontClassName(totalSignupCount)" :title="$n(totalSignupCount, 'integer')") {{ $n(totalSignupCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-info
                    div.card-header
                      i.fa.fa-calendar
                      span.font-weight-bold(:title="$t('ui.ftd')") {{ $t("ui.ftd") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalFtd)" :title="$n(totalFtd, 'currency')") {{ $n(totalFtd, 'currency') }}
                        div.text-uppercase.text-muted(:title="$n(totalFtdCount, 'integer')") {{ $t("ui.ftd_count") }} : {{ $n(totalFtdCount, 'integer') }}
              div.row
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-success
                    div.card-header
                      i.fas.fa-user
                      span.font-weight-bold(:title="$t('ui.no_deposit')") {{ $t("ui.no_deposit") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1
                            b-link(href="javascript:void(0);" @click="redirectTo('/report/currentMonthNonDepositor')" :class="$helpers.fontClassName(totalNoDepositCount)" :title="$n(totalNoDepositCount, 'integer')") {{ $n(totalNoDepositCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-warning
                    div.card-header
                      i.fas.fa-user
                      span.font-weight-bold(:title="$t('ui.no_login')") {{ $t("ui.no_login") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1
                            b-link(href="javascript:void(0);" @click="redirectTo('/report/currentMonthNoLogin')" :class="$helpers.fontClassName(totalNoLoginCount)" :title="$n(totalNoLoginCount, 'integer')") {{ $n(totalNoLoginCount, 'integer') }}
            div.col-sm-12.col-md-6.col-lg-6
              div.row
                div.col-sm-12.col-md-6.col-lg-6
                  div.card.card-accent-info
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_winner')") {{ $t("ui.top_winner") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%")
                        thead
                          tr
                            th(width="15%")
                              span #
                            th(width="45%")
                              span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                            th(width="40%")
                              span(:title="$t('ui.winner')") {{ $t("ui.winner") }}
                        tbody
                          tr(v-if="topWinnerList.length == 0")
                            td(colspan="3").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topWinnerList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.account_id") {{ item.account_id }}
                            td
                              span(:title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                div.col-sm-12.col-md-6.col-lg-6
                  div.card.card-accent-danger
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_loser')") {{ $t("ui.top_loser") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%")
                        thead
                          tr
                            th(width="15%")
                              span #
                            th(width="45%")
                              span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                            th(width="40%")
                              span(:title="$t('ui.loser')") {{ $t("ui.loser") }}
                        tbody
                          tr(v-if="topLoserList.length == 0")
                            td(colspan="3").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topLoserList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.account_id") {{ item.account_id }}
                            td
                              span(:title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
              div.row
                div.col-sm-12.col-md-6.col-lg-6
                  div.card.card-accent-info
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_deposit')") {{ $t("ui.top_deposit") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%")
                        thead
                          tr
                            th(width="15%")
                              span #
                            th(width="45%")
                              span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                            th(width="40%")
                              span(:title="$t('ui.amount')") {{ $t("ui.amount") }}
                        tbody
                          tr(v-if="topDepositList.length == 0")
                            td(colspan="3").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topDepositList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.account_id") {{ item.account_id }}
                            td
                              span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                div.col-sm-12.col-md-6.col-lg-6
                  div.card.card-accent-danger
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_withdrawal')") {{ $t("ui.top_withdrawal") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%")
                        thead
                          tr
                            th(width="15%")
                              span #
                            th(width="45%")
                              span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                            th(width="40%")
                              span(:title="$t('ui.amount')") {{ $t("ui.amount") }}
                        tbody
                          tr(v-if="topWithdrawalList.length == 0")
                            td(colspan="3").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topWithdrawalList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.account_id") {{ item.account_id }}
                            td
                              span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
              div.row
                div.col-sm-12.col-md-6.col-lg-6
                  div.card.card-accent-info
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_rebate_self')") {{ $t("ui.top_rebate_self") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%")
                        thead
                          tr
                            th(width="15%")
                              span #
                            th(width="45%")
                              span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                            th(width="40%")
                              span(:title="$t('ui.rebate')") {{ $t("ui.rebate") }}
                        tbody
                          tr(v-if="topRebateSelfList.length == 0")
                            td(colspan="3").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topRebateSelfList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.account_id") {{ item.account_id }}
                            td
                              span(:title="$n(item.rebate_self, 'currency')") {{ $n(item.rebate_self, 'currency') }}
                div.col-sm-12.col-md-6.col-lg-6
                  div.card.card-accent-danger
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_rebate_downline')") {{ $t("ui.top_rebate_downline") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%")
                        thead
                          tr
                            th(width="15%")
                              span #
                            th(width="45%")
                              span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                            th(width="40%")
                              span(:title="$t('ui.rebate')") {{ $t("ui.rebate") }}
                        tbody
                          tr(v-if="topRebateDownlineList.length == 0")
                            td(colspan="3").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topRebateDownlineList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.account_id") {{ item.account_id }}
                            td
                              span(:title="$n(item.rebate_downline, 'currency')") {{ $n(item.rebate_downline, 'currency') }}
              div.row
                div.col-sm-12.col-md-12.col-lg-12
                  div.card.card-accent-info
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_promotion')") {{ $t("ui.top_promotion") }}
                      span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%")
                        thead
                          tr
                            th(width="10%")
                              span #
                            th(width="20%")
                              span(:title="$t('ui.id')") {{ $t("ui.id") }}
                            th(width="50%")
                              span(:title="$t('ui.name')") {{ $t("ui.name") }}
                            th(width="20%")
                              span(:title="$t('ui.claim_frequency')") {{ $t("ui.claim_frequency") }}
                        tbody
                          tr(v-if="topPromotionList.length == 0")
                            td(colspan="4").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topPromotionList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.promotion_id") {{ item.promotion_id }}
                            td
                              span(:title="item.promotion_name") {{ item.promotion_name }}
                            td
                              span(:title="$n(item.claim_frequency, 'integer')") {{ $n(item.claim_frequency, 'integer') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import LineChart from '@/lineChart.js';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    LineChart
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    grandTotalDeposit: null,
    grandTotalDepositCount: null,
    grandTotalValidTurnover: null,
    grandTotalWinlose: null,
    grandTotalWithdrawal: null,
    grandTotalWithdrawalCount: null,
    grandTotalMemberCount: null,
    grandTotalActivePlayer: null,
    grandTotalBetCount: null,
    grandTotalRefereeCount: null,
    grandTotalSignupCount: null,
    grandTotalVerifiedCount: null,
    grandTotalFtdCount: null,
    grandTotalFtd: null,
    grandTotalNoDepositCount: null,
    grandTotalNoLoginCount: null,
    topWinnerList: [],
    topLoserList: [],
    topDepositList: [],
    topWithdrawalList: [],
    topRebateSelfList: [],
    topRebateDownlineList: [],
    topPromotionList: [],
    firstDataSet: null,
    secondDataSet: null,
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false
    },
    dateLabel: [],
    depositList: [],
    validTurnoverList: [],
    winloseList: [],
    withdrawalList: []
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    totalDeposit() {
      return this.grandTotalDeposit;
    },
    totalDepositCount() {
      return this.grandTotalDepositCount;
    },
    totalValidTurnover() {
      return this.grandTotalValidTurnover;
    },
    totalWinlose() {
      return this.grandTotalWinlose;
    },
    totalWithdrawal() {
      return this.grandTotalWithdrawal;
    },
    totalWithdrawalCount() {
      return this.grandTotalWithdrawalCount;
    },
    totalMemberCount() {
      return this.grandTotalMemberCount;
    },
    totalActivePlayer() {
      return this.grandTotalActivePlayer;
    },
    totalBetCount() {
      return this.grandTotalBetCount;
    },
    totalRefereeCount() {
      return this.grandTotalRefereeCount;
    },
    totalSignupCount() {
      return this.grandTotalSignupCount;
    },
    totalVerifiedCount() {
      return this.grandTotalVerifiedCount;
    },
    totalFtdCount() {
      return this.grandTotalFtdCount;
    },
    totalFtd() {
      return this.grandTotalFtd;
    },
    totalNoDepositCount() {
      return this.grandTotalNoDepositCount;
    },
    totalNoLoginCount() {
      return this.grandTotalNoLoginCount;
    },
    currentMonth() {
      return this.$moment(new Date).format("MMMM");
    }
  },
  mounted: function() {
    this.getDashboard();
  },
  methods: {
    getDashboard: function() {
      let url = config.dashboardUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        start_date: this.$moment(new Date).startOf("month").format("YYYY-MM-DD"),
        end_date: this.$moment(new Date).format("YYYY-MM-DD")
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                if(response.data.ds.summary.length > 0) {
                  var datatable = response.data.ds.summary;
                  for (var i = datatable.length - 1; i >= 0 ; i--) {
                    this.dateLabel.push(this.$moment(datatable[i]["working_date"]).format("DD"));
                    this.validTurnoverList.push(datatable[i]["valid_turnover"]);
                    this.winloseList.push(datatable[i]["winlose"]);
                    this.depositList.push(datatable[i]["deposit_amount"]);
                    this.withdrawalList.push(datatable[i]["withdrawal_amount"]);
                  }

                  if(response.data.ds.grand_total.length > 0) {
                    this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                    this.grandTotalWinlose = response.data.ds.grand_total[0]["winlose"];
                    this.grandTotalDeposit = response.data.ds.grand_total[0]["deposit_amount"];
                    this.grandTotalDepositCount = response.data.ds.grand_total[0]["deposit_count"];
                    this.grandTotalWithdrawal = response.data.ds.grand_total[0]["withdrawal_amount"];
                    this.grandTotalWithdrawalCount = response.data.ds.grand_total[0]["withdrawal_count"];
                    this.grandTotalBetCount = response.data.ds.grand_total[0]["bet_count"];
                    this.grandTotalRefereeCount = response.data.ds.grand_total[0]["referee_count"];
                    this.grandTotalSignupCount = response.data.ds.grand_total[0]["signup_count"];
                    this.grandTotalVerifiedCount = response.data.ds.grand_total[0]["verified_count"];
                    this.grandTotalFtdCount = response.data.ds.grand_total[0]["ftd_count"];
                    this.grandTotalFtd = response.data.ds.grand_total[0]["ftd_amount"];
                  }

                  this.integrateChartData();

                }

                if (response.data.ds.active_player.length > 0) {
                  this.grandTotalActivePlayer = response.data.ds.active_player.length > 0 ? response.data.ds.active_player[0].active_player : 0;
                }

                if (response.data.ds.member_count.length > 0) {
                  this.grandTotalMemberCount = response.data.ds.member_count.length > 0 ? response.data.ds.member_count[0].member_count : 0;
                }

                if (response.data.ds.top_winner.length > 0) {
                  this.topWinnerList = response.data.ds.top_winner;
                }

                if (response.data.ds.top_loser.length > 0) {
                  this.topLoserList = response.data.ds.top_loser;
                }

                if (response.data.ds.top_deposit.length > 0) {
                  this.topDepositList = response.data.ds.top_deposit;
                }

                if (response.data.ds.top_withdrawal.length > 0) {
                  this.topWithdrawalList = response.data.ds.top_withdrawal;
                }

                if (response.data.ds.top_promotion.length > 0) {
                  this.topPromotionList = response.data.ds.top_promotion;
                }

                if (response.data.ds.top_rebate_self.length > 0) {
                  this.topRebateSelfList = response.data.ds.top_rebate_self;
                }

                if (response.data.ds.top_rebate_downline.length > 0) {
                  this.topRebateDownlineList = response.data.ds.top_rebate_downline;
                }

                if (response.data.ds.no_deposit_count.length > 0) {
                  this.grandTotalNoDepositCount = response.data.ds.no_deposit_count.length > 0 ? response.data.ds.no_deposit_count[0].no_deposit_count : 0;
                }

                if (response.data.ds.no_login_count.length > 0) {
                  this.grandTotalNoLoginCount = response.data.ds.no_login_count.length > 0 ? response.data.ds.no_login_count[0].no_login_count : 0;
                }
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    redirectTo: function(link) {
      this.$router.push(link);
    },
    integrateChartData: function () {
      this.firstDataSet = {
        labels: this.dateLabel,
        datasets: [
          {
            label: this.$t("ui.turnover"),
            backgroundColor: '#52BE80',
            data: this.validTurnoverList
          },
          {
            label: this.$t("ui.deposit"),
            backgroundColor: '#26C6DA',
            data: this.depositList
          }
        ]
      };
      this.secondDataSet = {
        labels: this.dateLabel,
        datasets: [
          {
            label: this.$t("ui.winlose"),
            backgroundColor: '#FFF176',
            data: this.winloseList
          },
          {
            label: this.$t("ui.withdrawal"),
            backgroundColor: '#FFB74D',
            data: this.withdrawalList
          }
        ]
      };
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss">

.badge {
  padding: 2.5px 4px !important;
}
.text-value {
  h1 {
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
}
</style>